import React, { Component } from 'react';
import { Modal, Panel, Button, Glyphicon } from 'react-bootstrap'

export class HandleMessage extends Component {
    renderHeaderIcon() {
        const { icon } = this.props;

        if (undefined === icon || null === icon || "" === icon) {
            return null;
        }

        return (
            <Glyphicon glyph={icon} />
        );
    }

    renderButton() {
        const { noButtons } = this.props;

        if (noButtons) {
            return null;
        }

        const { buttonText } = this.props

        return (
            <div className="pull-right">
                <Button onClick={this.props.onHide}> {buttonText || "OK"} </Button>
            </div>
        );
    }

    render() {
        const { show, style, title, message, small, large, sticky } = this.props;

        if (!show) {
            return null;
        }

        const messageLines = [];
        if ("string" === typeof message) {
            message.split("\n").map((msg, i) => messageLines.push(<div key={`message-${i}`}>{msg}</div>));
        }
        else {
            messageLines.push(<div key="message-line">{message}</div>);
        }

        return (
            <Modal
                bsSize={small ? "small" : (large ? "large" : null)}
                onHide={sticky ? null : this.props.onHide}
                show={true} >
                <Modal.Body className="padding-0" >
                    <Panel bsStyle={style} className="margin-bottom-0 border-0">
                        <Panel.Heading>
                            <h3 className="alert-title">{this.renderHeaderIcon()}&nbsp;{title}</h3>
                        </Panel.Heading>

                        <Panel.Body>
                            <div>
                                <div className="padding-top-20 padding-bottom-20 font-size-12 break-word">
                                    {messageLines}
                                </div>
                                {this.renderButton()}
                            </div>
                        </Panel.Body>
                    </Panel>
                </Modal.Body>
            </Modal>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/HandleMessage.js